<template>
  <Dialog
      id="group-creation-modal"
      v-model:visible="visible"
      :header="t('CREATE_GROUP')"
      modal
      class="group-creation-modal"
      :draggable="false"
      :dismissable-mask="true"
  >
    <div class="row">
      <div class="col">
        <add-group-form
            ref="groupFormRef"
            :module="module"
            :trainers="trainers"
            @submit-group="createGroup"
        />
      </div>
    </div>
    <template #footer>
      <Button :label="t('CONFIRM')" @click="handleOk"/>
    </template>
  </Dialog>
</template>

<script setup>
import EventBus from "@/util/eventBus";
import addGroupForm from "@/views/components/forms/AddGroupForm.vue";
import {onBeforeUnmount, onMounted, ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import {useToast} from "@/util/toastUtils";

const emit = defineEmits(["added-group"]);
const props = defineProps({ module: Object, trainers: Array, isAdmin: Boolean });
const axios = injectAxios();
const {t} = useI18n();
const toast = useToast();

const groupFormRef = ref(null);
const visible = ref(false);

onMounted(() => {
  EventBus.$on("show-group-creation-modal", showModal);
});

onBeforeUnmount(() => {
  EventBus.$off("show-group-creation-modal", showModal);
});

function handleOk() {
  groupFormRef.value?.submitForm();
}

async function createGroup(formData) {
  formData.training = props.module;
  const resp = await axios.post("/training/group/", formData);
  toast.makeSuccessToast(t("ADDED_GROUP"));
  emit("added-group", resp.data);
  visible.value = false;
}

function showModal() {
  visible.value = true;
}
</script>
